import { defineComponent as _defineComponent } from 'vue'
interface Props {
  items?: any[];
}
interface Emits {
  (e: 'input', data: string): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UiSearchFormPopularQueries',
  props: {
    items: { default: () => [] }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', data: string): void;
}), expose: any, slots: any, attrs: any }) {





const selectItem = (item: string) => {
  emit('input', item);
};

return { __sfc: true,emit, selectItem }
}

})